import React, { useState } from 'react';
import { IconChevronDown, IconClose, IconCalendar, IconDashboard } from '../common/Icons';

const Sidebar = ({ isOpen, setIsOpen, selectedYear, setSelectedYear, view, setView, availableYears }) => {
    const [isYearMenuOpen, setIsYearMenuOpen] = useState(true);
    
    const handleSetView = (newView, year = null) => {
        setView(newView);
        if (year) {
            setSelectedYear(year);
        }
        if (window.innerWidth < 768) {
            setIsOpen(false);
        }
    };

    return (
        <React.Fragment>
            <div 
                className={`fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden transition-opacity ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
                onClick={() => setIsOpen(false)}
            ></div>
            <aside className={`fixed top-0 left-0 w-64 h-full bg-gray-800 text-white z-40 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 transition-transform duration-300 ease-in-out`}>
                <div className="p-4 flex justify-between items-center border-b border-gray-700">
                    <h2 className="text-2xl font-bold">เมนู</h2>
                    <button onClick={() => setIsOpen(false)} className="md:hidden text-gray-400 hover:text-white">
                        <IconClose />
                    </button>
                </div>
                <nav className="mt-4">
                    <a
                        href="/#"
                        onClick={(e) => { e.preventDefault(); handleSetView('dashboard'); }}
                        className={`flex items-center px-4 py-3 text-lg transition-colors duration-200 ${view === 'dashboard' ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`}
                    >
                        <IconDashboard />
                        <span className="ml-3 font-semibold">Dashboard</span>
                    </a>
                    <button
                        onClick={() => setIsYearMenuOpen(!isYearMenuOpen)}
                        className="w-full flex justify-between items-center px-4 py-3 text-lg transition-colors duration-200 text-gray-300 hover:bg-gray-700 hover:text-white focus:outline-none"
                    >
                        <div className="flex items-center">
                            <IconCalendar />
                            <span className="ml-3 font-semibold">เลือกปีการแข่งขัน</span>
                        </div>
                        <span className={`transform transition-transform duration-300 ${isYearMenuOpen ? '' : '-rotate-90'}`}>
                            <IconChevronDown />
                        </span>
                    </button>
                    <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isYearMenuOpen ? 'max-h-96' : 'max-h-0'}`}>
                        <ul className="pt-2 pb-4 pl-8">
                            {availableYears.length > 0 ? (
                                availableYears.map(year => (
                                    <li key={`year-menu-${year}`}>
                                        <a
                                            href="/#"
                                            onClick={(e) => { e.preventDefault(); handleSetView('table', year); }}
                                            className={`block px-4 py-2 text-base rounded-md transition-colors duration-200 ${view === 'table' && selectedYear === year ? 'bg-blue-600 text-white' : 'text-gray-400 hover:bg-gray-700 hover:text-white'}`}
                                        >
                                            ปี {year} / {year + 543}
                                        </a>
                                    </li>
                                ))
                            ) : (
                                <li className="px-4 py-2 text-gray-500">กำลังโหลดปี...</li>
                            )}
                        </ul>
                    </div>
                </nav>
            </aside>
        </React.Fragment>
    );
};

export default Sidebar;
